import { useState } from "react";
import { useForm } from "react-hook-form";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { BASE_URL } from "../utils/utilsFunction";

const ApplicationForm = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [submitSuccess, setSubmitSuccess] = useState(false);
  // const [formData, setFormData] = useState({
  //   fullName: "",
  //   email: "",
  //   phone: "",
  //   dob: "",
  //   address: "",
  //   resume: null,
  //   education: null,
  //   aadhaar: null,
  //   pan: null,
  // });
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);

  const onSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      setError(null);
      setIsRegistered(false);

      const formData = new FormData();

      // Add text fields with exact field names
      formData.append("full_name", data.fullName);
      formData.append("email", data.email);
      formData.append("phone", data.phone);
      formData.append("date_of_birth", new Date(data.dob).toISOString());
      formData.append("address", data.address || "");

      //   formData.append("submitted_by", "lead");

      // Add files with exact field names
      if (data.resume[0]) {
        formData.append("resume", data.resume[0]);
      }
      if (data.aadhaar[0]) {
        formData.append("aadhar_card", data.aadhaar[0]);
      }
      if (data.pan[0]) {
        formData.append("pan_card", data.pan[0]);
      }
      if (data.education[0]) {
        formData.append("edu_certificate", data.education[0]);
      }

      const response = await fetch(
        `${BASE_URL}/api/v1/leads/career-application`,
        // "http://localhost:8080/api/v1/leads/career-application",
        {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
          },
        }
      );

      const result = await response.json();

      if (!response.ok) {
        if (
          result.message?.toLowerCase().includes("already registered") ||
          result.message?.toLowerCase().includes("already exists")
        ) {
          setIsRegistered(true);
          throw new Error("You have already applied for this position.");
        }
        throw new Error(result.message || "Failed to submit application");
      }

      console.log("Success:", result);
      setSubmitSuccess(true);
      reset();

      setTimeout(() => {
        window.location.href = "https://globelinkplacement.com/";
      }, 3000);
    } catch (error) {
      console.error("Error submitting form:", error);
      setError(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="font-sans min-h-screen flex flex-col bg-gray-50">
      <Navbar />
      {/* Form Section */}
      <main className="container mx-auto px-4 py-24 flex-grow">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white shadow-lg rounded-lg overflow-hidden">
            <div className="bg-gray-800 text-white p-6">
              <h2 className="text-2xl font-bold mb-2">Application Form</h2>
              <p className="text-sm text-gray-300">
                Fields marked with * are mandatory
              </p>
            </div>
            <div className="p-8">
              {isRegistered && (
                <div className="mb-6 bg-yellow-100 border border-yellow-400 text-yellow-800 px-4 py-3 rounded relative">
                  <strong className="font-bold">Already Registered! </strong>
                  <span className="block sm:inline">
                    You have already submitted an application. Please wait for
                    our response or contact support for any queries.
                  </span>
                  <button
                    className="absolute top-0 right-0 px-4 py-3"
                    onClick={() => setIsRegistered(false)}
                  >
                    <span className="text-2xl">&times;</span>
                  </button>
                </div>
              )}

              {submitSuccess && (
                <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
                  Your application has been submitted successfully! We'll
                  contact you soon.
                </div>
              )}

              {error && (
                <div className="mb-6 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label
                      htmlFor="fullName"
                      className="block mb-1 font-medium"
                    >
                      Full Name *
                    </label>
                    <input
                      type="text"
                      id="fullName"
                      {...register("fullName", {
                        required: "Full name is required",
                      })}
                      className="w-full px-3 py-2 border rounded-md"
                      placeholder="Enter your full name"
                    />
                    {errors.fullName && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.fullName.message}
                      </p>
                    )}
                  </div>
                  <div>
                    <label htmlFor="email" className="block mb-1 font-medium">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      id="email"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^\S+@\S+$/i,
                          message: "Invalid email address",
                        },
                      })}
                      className="w-full px-3 py-2 border rounded-md"
                      placeholder="Enter your email"
                    />
                    {errors.email && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.email.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="phone" className="block mb-1 font-medium">
                      Phone Number *
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      {...register("phone", {
                        required: "Phone number is required",
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message: "Invalid phone number",
                        },
                      })}
                      className="w-full px-3 py-2 border rounded-md"
                      placeholder="Enter your phone number"
                    />
                    {errors.phone && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.phone.message}
                      </p>
                    )}
                  </div>
                  <div>
                    <label htmlFor="dob" className="block mb-1 font-medium">
                      Date of Birth *
                    </label>
                    <input
                      type="date"
                      id="dob"
                      {...register("dob", {
                        required: "Date of birth is required",
                      })}
                      className="w-full px-3 py-2 border rounded-md"
                      max={new Date().toISOString().split("T")[0]}
                    />
                    {errors.dob && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.dob.message}
                      </p>
                    )}
                  </div>
                </div>

                <div>
                  <label htmlFor="address" className="block mb-1 font-medium">
                    Address
                  </label>
                  <textarea
                    id="address"
                    {...register("address")}
                    className="w-full px-3 py-2 border rounded-md"
                    rows={3}
                    placeholder="Enter your complete address (optional)"
                  ></textarea>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="resume" className="block mb-1 font-medium">
                      Resume/CV *
                    </label>
                    <input
                      type="file"
                      id="resume"
                      {...register("resume", {
                        required: "Resume is required",
                      })}
                      className="w-full px-3 py-2 border rounded-md"
                      accept=".pdf,.doc,.docx"
                    />
                    <p className="text-sm text-gray-500 mt-1">
                      Upload your resume (PDF, DOC, DOCX)
                    </p>
                    {errors.resume && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.resume.message}
                      </p>
                    )}
                  </div>
                  <div>
                    <label
                      htmlFor="education"
                      className="block mb-1 font-medium"
                    >
                      Education Certificate
                    </label>
                    <input
                      type="file"
                      id="education"
                      {...register("education")}
                      className="w-full px-3 py-2 border rounded-md"
                      accept=".pdf,.jpg,.jpeg,.png"
                    />
                    <p className="text-sm text-gray-500 mt-1">
                      Upload your certificate (PDF, JPG, PNG)
                    </p>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="aadhaar" className="block mb-1 font-medium">
                      Aadhaar Card
                    </label>
                    <input
                      type="file"
                      id="aadhaar"
                      {...register("aadhaar")}
                      className="w-full px-3 py-2 border rounded-md"
                      accept=".pdf,.jpg,.jpeg,.png"
                    />
                    <p className="text-sm text-gray-500 mt-1">
                      Upload your Aadhaar card (PDF, JPG, PNG)
                    </p>
                  </div>
                  <div>
                    <label htmlFor="pan" className="block mb-1 font-medium">
                      PAN Card
                    </label>
                    <input
                      type="file"
                      id="pan"
                      {...register("pan")}
                      className="w-full px-3 py-2 border rounded-md"
                      accept=".pdf,.jpg,.jpeg,.png"
                    />
                    <p className="text-sm text-gray-500 mt-1">
                      Upload your PAN card (PDF, JPG, PNG)
                    </p>
                  </div>
                </div>

                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`px-6 py-3 bg-red-900 text-white rounded-lg transition-all duration-200 font-medium
                      ${
                        isSubmitting
                          ? "opacity-70 cursor-not-allowed"
                          : "hover:bg-red-800"
                      }`}
                  >
                    {isSubmitting ? "Submitting..." : "Submit Application"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ApplicationForm;
